import { createSlice } from "@reduxjs/toolkit";
const isAdminFromLocalStg = localStorage.getItem('isAdmin')
console.log(isAdminFromLocalStg)

const roleSlice = createSlice({
    name: "plan",
    initialState: {
        isAdmin: isAdminFromLocalStg === null || isAdminFromLocalStg === 'true' ? true : false
    },
    reducers: {
        setIsAdmin: (state, action) => {
            state.isAdmin = action.payload;
            localStorage.setItem('isAdmin', action.payload);
        },
    },
});

export const { setIsAdmin } = roleSlice.actions;
export default roleSlice;
